interface FormulaProps {
  formula: string;
}

/**
 * Inline formula callout with a muted background and an accent "Formula" label.
 * Shared by the metrics cheat sheet and the calculator content sections.
 */
const Formula = ({ formula }: FormulaProps) => (
  <div className="mt-5 rounded-xl bg-muted/50 px-5 py-4">
    <span className="block text-[0.65rem] uppercase tracking-[0.16em] text-accent mb-1.5">
      Formula
    </span>
    <p className="text-[15px] md:text-base leading-relaxed text-foreground tracking-tight">
      {formula}
    </p>
  </div>
);

export default Formula;
